/**
 * Spanish overrides for `public/pages/permit-department.json` (section keys must match JSON).
 */
export const permitDepartmentPagePatches = {
    es: {
        title: 'Permisos por departamento',
        sections: {
            'department-permits': {
                nav: {
                    logoText: 'WEST VIRGINIA',
                    links: [
                        { label: 'Inicio', href: '/' },
                        { label: 'Sobre nosotros', href: '/#why-choose' },
                        { label: 'Agencias', href: '/#agencies' },
                        { label: 'Departamentos', href: '/#departments' },
                        { label: 'Cómo funciona', href: '/#how-it-works' },
                    ],
                    loginLabel: 'Iniciar sesión',
                    loginHref: '/login',
                    ctaLabel: 'Registrarse',
                    ctaHref: '/register',
                },
                departments: {
                    commerce: {
                        title: 'Comercio',
                        subtitle: 'Negocios, licencias y desarrollo económico',
                        matchTitles: ['1', 'Commerce', 'commerce', 'Department of Commerce'],
                    },
                    env: {
                        title: 'Medio ambiente',
                        subtitle: 'Protección ambiental y recursos naturales',
                        matchTitles: ['4', 'Environment', 'Environmental', 'Environmental Protection', 'DEP', 'Industry'],
                    },
                    transportation: {
                        title: 'Transporte',
                        subtitle: 'Carreteras, vehículos motorizados e infraestructura',
                        matchTitles: ['5', 'Transportation', 'DOT', 'DMV', 'Infrastructure'],
                    },
                    health: {
                        title: 'Salud',
                        subtitle: 'Licencias y permisos de salud pública',
                        matchTitles: ['2', 'Health', 'DH', 'Department of Health'],
                    },
                    revenue: {
                        title: 'Ingresos',
                        subtitle: 'Impuestos y servicios de rentas',
                        matchTitles: ['3', 'Revenue', 'Tax', 'Department of Revenue'],
                    },
                },
                agenciesHeading: 'Agencias',
                agenciesSubheading: 'Abra una agencia para ver permisos, tasas, plazos y detalles de la solicitud.',
                searchPlaceholder: 'Buscar…',
                searchButtonLabel: 'Buscar',
            },
            footer: {
                logoText: 'WEST VIRGINIA',
                description: 'Portal unificado para permisos y licencias de West Virginia.',
                linkGroups: [
                    {
                        title: 'Departamentos',
                        links: [
                            { label: 'Comercio', href: '/permits/commerce' },
                            { label: 'Medio ambiente', href: '/permits/env' },
                            { label: 'Salud', href: '/permits/health' },
                            { label: 'Ingresos', href: '/permits/revenue' },
                            { label: 'Transporte', href: '/permits/transportation' },
                        ],
                    },
                    {
                        title: 'Soporte',
                        links: [
                            { label: 'Ayuda y preguntas frecuentes', href: '/faq' },
                            { label: 'Contáctenos', href: '/contact' },
                            { label: 'Sobre nosotros', href: '/about' },
                        ],
                    },
                    {
                        title: 'Legal',
                        links: [
                            { label: 'Política de privacidad', href: 'https://www.wv.gov/privacy-policy', openInNewTab: true },
                            { label: 'Términos del servicio', href: '/terms' },
                        ],
                    },
                ],
                copyright: '© 2026 West Virginia Government. Todos los derechos reservados.',
            },
        },
    },
};
